export const FormDesign = {
  CLASSIC: {
    id: "classic",
    name: "app.editForm.design.classic",
  },
  CLEAN: {
    id: "clean",
    name: "app.editForm.design.clean",
  },
} as const;

export type FormDesignId =
  (typeof FormDesign)[keyof typeof FormDesign]["id"];

export const DEFAULT_FORM_DESIGN: FormDesignId = FormDesign.CLASSIC.id;

export function getFormDesignClass(design?: string): string {
  return design === FormDesign.CLEAN.id
    ? "web-form-fields--clean"
    : "web-form-fields--classic";
}

export function isCleanFormDesign(design?: string): boolean {
  return design === FormDesign.CLEAN.id;
}
